import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '@wix/wix-ui-test-utils/base-driver';
import ResizeObserverPolyfill from 'resize-observer-polyfill';
import { TABS_DATA_HOOKS, TABS_DATA_KEYS } from './dataHooks';

if (typeof window !== 'undefined') {
  window.ResizeObserver = ResizeObserverPolyfill;
}

const getTab = (base: UniDriver, index: number) =>
  base.$(`[data-hook="${TABS_DATA_HOOKS.tab}-${index}"]`);

const getTabs = (base: UniDriver) =>
  base.$(`[data-hook="${TABS_DATA_HOOKS.scrollableTabs}"]`);

export const tabsDriverFactory = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),
    getTitleAt: (index: number) => getTab(base, index).text(),
    clickTabAt: (index: number) => getTab(base, index).click(),
    getActiveTabIndex: async () =>
      +(await base
        .$(`[${TABS_DATA_KEYS.tabIsActive}="true"]`)
        .attr(TABS_DATA_KEYS.tabIndex)),
    isMobile: async () => (await base.attr(TABS_DATA_KEYS.mobile)) === 'true',
    getSkin: () => base.attr(TABS_DATA_KEYS.skin),
    getAlignment: () => getTabs(base).attr(TABS_DATA_KEYS.alignment),
    getVariant: () => getTabs(base).attr(TABS_DATA_KEYS.variant),
    getNavButtonsShown: () => base.attr(TABS_DATA_KEYS.navButtons),
    clickRightNavButton: () =>
      base.$(`[data-hook="${TABS_DATA_HOOKS.rightNavButton}"]`).click(),
    clickLeftNavButton: () =>
      base.$(`[data-hook="${TABS_DATA_HOOKS.leftNavButton}"]`).click(),
  };
};

export type TabsDriver = ReturnType<typeof tabsDriverFactory>;
